import React from 'react';
import TableCell from '@material-ui/core/TableCell';
import Checkbox from '@material-ui/core/Checkbox';
import TableRow from '@material-ui/core/TableRow';
import Chip from '@material-ui/core/Chip';
import { timeFromNow, getDateinDesiredFormat } from '../../../../@jumbo/utils/dateHelper';
import { Block, Call, CheckCircleOutline, Delete, Edit, Email, Mail, MoreHoriz, Visibility } from '@material-ui/icons';
import CmtDropdownMenu from '../../../../@coremat/CmtDropdownMenu';
import CmtAvatar from '../../../../@coremat/CmtAvatar';
import { Box, Button, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useDispatch } from 'react-redux';
import styles from '../../../../styles/loadboard.module.scss';

const useStyles = makeStyles(theme => ({
  titleRoot: {
    marginBottom: 2,
    fontSize: 14,
    letterSpacing: 0.25,
    color: theme.palette.common.dark,
  },
  chipRoot: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: '0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)',
    borderRadius: 4,
    marginRight: 10,
    marginBottom: 12,
    height: 26,
    fontSize: 14,
    color: theme.palette.text.secondary,
    cursor: 'pointer',
  },
}));

const getUserActions = user => {
  const actions = [
    { action: 'view', label: 'View', icon: <Visibility /> },
    { action: 'book', label: 'Book', icon: <CheckCircleOutline /> },
  ];

  // if (user.status === 'active') {
  //   actions.push({ action: 'suspend', label: 'Suspend', icon: <Block /> });
  // } else {s
  //   actions.push({
  //     action: 'activate',
  //     label: 'Reactivate',
  //     icon: <CheckCircleOutline />,
  //   });
  // }

  // actions.push({ action: 'delete', label: 'Delete', icon: <Delete /> });
  return actions;
};

const DedicatedLoadListRow = ({ row, onLoadBook, onCall, onBid }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  return (
    <TableRow hover tabIndex={-1} key={row.id}>
      {/* <TableCell padding="checkbox">
        <Checkbox checked={isItemSelected} inputProps={{ 'aria-labelledby': labelId }} />
      </TableCell> */}
      {/* <TableCell component="th" id={labelId} scope="row" padding="none">
        <Box display="flex" alignItems="center">
          <Box mr={{ xs: 4, md: 5 }}>
            <CmtAvatar size={40} src={row.profile_pic} alt={row.name} />
          </Box>
          <div>
            <Typography className={classes.titleRoot} component="div" variant="h4">
              {row.name}
            </Typography>
          </div>
        </Box>
      </TableCell> */}
      {/* <TableCell>{row.source}</TableCell> */}

      <TableCell>{row.origin_city}</TableCell>
      <TableCell>{row.pickup_location}</TableCell>
      <TableCell>{getDateinDesiredFormat(row.pick_up_date, 'MM/DD')}</TableCell>
      <TableCell>{row.pick_up_time_start}</TableCell>
      <TableCell>{row.dh_o}</TableCell>
      <TableCell>{row.destination.name}</TableCell>
      <TableCell>{row.drop_off_location}</TableCell>
      <TableCell>{getDateinDesiredFormat(row.drop_off_date, 'MM/DD')}</TableCell>
      <TableCell>{row.delivery_date_time}</TableCell>
      <TableCell>{row.dh_d}</TableCell>
      <TableCell>{row.trip_distance}</TableCell>
      <TableCell>{Number(row.rate) || 'NA'}</TableCell>
      <TableCell>{row.trailer_type}</TableCell>
      <TableCell>
        <Chip className={classes.chipRoot} label={row.full_partial} />
      </TableCell>
      <TableCell>{row.length}</TableCell>
      <TableCell>{row.weight}</TableCell>
      <TableCell>{row.driver_type}</TableCell>
      <TableCell>{row.commodity}</TableCell>
      <TableCell>{row.comments}</TableCell>
      <TableCell>{row.cell}</TableCell>
      {/* <TableCell
        align="center"
        style={{ textAlign: 'left', whiteSpace: 'nowrap' }}
        onClick={event => event.stopPropagation()}>
        {row.is_book_allowed ? (
          <Button
            variant="contained"
            color="primary"
            size="small"
            style={{ marginRight: '10px' }}
            onClick={() => {
              onLoadBook(row);
            }}>
            Book
          </Button>
        ) : null}
        {row.is_bid_allowed ? (
          <Button
            variant="outlined"
            color="primary"
            size="small"
            style={{ marginRight: '10px' }}
            onClick={() => {
              onBid(row);
            }}>
            Bid
          </Button>
        ) : null}
        {!row.is_bid_allowed && !row.is_book_allowed && row.company_phone ? (
          <Call
            style={{ marginRight: '10px' }}
            onClick={() => {
              onCall(row);
            }}
          />
        ) : null}
        {!row.is_bid_allowed && !row.is_book_allowed && row.company_email ? (
          <a
            href={`mailto:${row.company_email}`}
            target="_blank"
            className="secondaryBtn extraSmallBtn"
            style={{ width: '100%', color: 'black' }}
            onClick={() => (window.location = `mailto:${row.company_email}`)}
            rel="noreferrer">
            <Email />
          </a>
        ) : null}
      </TableCell> */}
    </TableRow>
  );
};

export default React.memo(DedicatedLoadListRow);
